import { Avatar, Breadcrumb, Layout, Menu, Dropdown, Button, Drawer } from 'antd';
import { DownOutlined, DownloadOutlined, LockOutlined, TranslationOutlined, UserOutlined, ZhihuOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useUser } from "../../../context/UserContext";
import { useModal } from "../../../context/ModalContext";
import ChangePasswordModal from "../../../../app/user/ChangePasswordModal";
import { useEffect, useState } from "react";
import ApiService from "../../../service/api-service";
import { LocalStorageService } from "../../../service/local-storage-service";
import { useHistory } from "react-router-dom";
import { Pages } from "../../../../AppRouter";
import { useApp } from "../../../context/AppContext";
import { BrowserView, MobileView } from "react-device-detect";
import { useIsSmallScreen } from "../../../utils/useMediaQuery";

const { SubMenu } = Menu;

/** Kullanıcının işletim sistemi; InstallerTarget anahtarlarıyla eşleşir. */
function detectPlatform() {
    const agent = navigator.userAgent;
    if (/Windows/i.test(agent)) return 'windows';
    if (/Mac OS X|Macintosh/i.test(agent)) return 'osx';
    if (/Android/i.test(agent)) return null;
    if (/Linux|X11/i.test(agent)) return 'linux';
    return null;
}

export default function ProfileDropdown() {
    const isSmallScreen = useIsSmallScreen(992);
    const { t } = useTranslation();
    const { signOut, setUser, user } = useUser();
    const { openModal } = useModal();

    // avatar baş harfleri: "Ahmet Yılmaz" → "AY" (tek isimse tek harf)
    const initials = (user?.data?.name || '')
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map(part => part[0])
        .join('')
        .toUpperCase();
    const history = useHistory()
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [installers, setInstallers] = useState([]);

    useEffect(() => {
        let cancelled = false;
        ApiService.Weasis.GetInstallers().then(response => {
            if (!cancelled && response?.success) setInstallers(response.data ?? []);
        });
        return () => { cancelled = true; };
    }, []);

    const onClick = (item) => {
        if (item.key === 'logout') {
            signOut()
        }
        else if (item.key === 'change-password') {
            openModal(t('Change Password'), <ChangePasswordModal />, null, 420)
            setDrawerOpen(false)
        }
        else if (item.key === 'dictionary') {
            history.push(Pages.User.Dictionary)
            setDrawerOpen(false)
        }
        else if (['en', 'tr', 'uz', 'ru'].includes(item.key)) {
            LocalStorageService.setLanguage(item.key)
            window.location.reload()
        }
    }

    const downloadLink = (installer) => (
        <a href={`${window.AppSettings.server.api}/Public/launcher/${installer.fileName}`} download>
            {installer.displayName}
        </a>
    );

    // Tek kurulum dosyası varsa düz bir satır, birden fazlaysa platform alt menüsü.
    const downloadItem = () => {
        if (installers.length === 0) return null;

        if (installers.length === 1) {
            return (
                <Menu.Item key="download-viewer" icon={<DownloadOutlined />}>
                    <a href={`${window.AppSettings.server.api}/Public/launcher/${installers[0].fileName}`} download>
                        {`${t('Viewer Download')} (${installers[0].displayName})`}
                    </a>
                </Menu.Item>
            );
        }

        const platform = detectPlatform();
        const ordered = [...installers].sort((a, b) => (b.key === platform) - (a.key === platform));

        return (
            <SubMenu key="download-viewer" icon={<DownloadOutlined />} title={t('Viewer Download')}>
                {ordered.map(installer => (
                    <Menu.Item key={`download-${installer.key}`}>{downloadLink(installer)}</Menu.Item>
                ))}
            </SubMenu>
        );
    };

    const menu = (
        <Menu onClick={onClick}>
            <SubMenu icon={<ZhihuOutlined />} key={'languages'} title={'Language'}>
                <Menu.Item key="en">
                    English
                </Menu.Item>
                <Menu.Item key="tr">
                    Türkçe
                </Menu.Item>
                <Menu.Item key="uz">
                    Uzbek
                </Menu.Item>
                <Menu.Item key="ru">
                    Русский
                </Menu.Item>
            </SubMenu>
            <Menu.Item key="dictionary" icon={<TranslationOutlined />}>
                {t('Dictionary')}
            </Menu.Item>
            <Menu.Item key="change-password" icon={<LockOutlined />}>
                {t('Change Password')}
            </Menu.Item>
            {downloadItem()}
            <Menu.Item key="logout" icon={<UserOutlined />}>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    const mobileMenu = (
        <Menu onClick={onClick} mode="inline" className="mobile-nav" style={{ border: 'none' }}>
            <SubMenu icon={<ZhihuOutlined />} key={'languages'} title={t('Language')}>
                <Menu.Item key="en">
                    English
                </Menu.Item>
                <Menu.Item key="tr">
                    Türkçe
                </Menu.Item>
            </SubMenu>
            <Menu.Item key="dictionary" icon={<TranslationOutlined />}>
                {t('Dictionary')}
            </Menu.Item>
            <Menu.Item key="change-password" icon={<LockOutlined />}>
                {t('Change Password')}
            </Menu.Item>
            {downloadItem()}
            <Menu.Item key="logout" icon={<UserOutlined />} danger>
                {t('Logout')}
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            {
                !isSmallScreen && (
                    <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
                        {/* header eylemi: baş harfli avatar + ad + ok. v4'teki "bottomCenter"
                            yerleşimi v5'te YOK — sessizce yanlış hizalanıyordu. */}
                        <Button type="text" className="header-user">
                            <Avatar size={28} className="header-user-avatar">
                                {initials || <UserOutlined />}
                            </Avatar>
                            <span className="header-user-name">{user && user.data.name}</span>
                            <DownOutlined className="header-user-caret" />
                        </Button>
                    </Dropdown>
                )
            }
            {
                isSmallScreen && (
                    <>
                        <Button
                            type="text"
                            className="header-action"
                            aria-label={user?.data?.name || 'Profile'}
                            onClick={() => setDrawerOpen(true)}
                            icon={
                                <Avatar size={28} className="header-user-avatar">
                                    {initials || <UserOutlined />}
                                </Avatar>
                            }
                        />
                        <Drawer
                            title={user && user.data.name}
                            className="nav-drawer"
                            placement="right"
                            onClose={() => setDrawerOpen(false)}
                            open={drawerOpen}
                            width="min(86vw, 320px)"
                            styles={{ body: { padding: 0 } }}
                        >
                            {mobileMenu}
                        </Drawer>
                    </>
                )
            }
        </>
    )
}
